var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.997 3c3.575 0 5.797 4.367 5.897 4.553.14.281.14.613 0 .894l-.141.26C13.203 9.68 11.113 13 7.997 13 4.422 13 2.2 8.633 2.105 8.447a1.001 1.001 0 01-.052-.77l.052-.124C2.2 7.367 4.422 3 7.997 3zm0 2c-1.806 0-3.28 2.076-3.85 3.006C4.827 9.129 6.314 11 7.997 11c1.806 0 3.28-2.076 3.85-3.006C11.167 6.872 9.68 5 7.997 5zm0 1.5a1.5 1.5 0 11-.001 3.001A1.5 1.5 0 017.997 6.5z"
  })));
}
export default SvgEye;